import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as HomeReducers from './home.reducer';

export const featureSelector = createFeatureSelector<HomeReducers.State>('home');


export const loaded = createSelector(
  featureSelector,
  state => state.loaded
);


export const isLoadingDashboards = createSelector(
  featureSelector,
  state => state.loadingDashboards
);

export const getDashboards = createSelector(
  featureSelector,
  state => state.dashboards
);

export const isLoadingVisuals = createSelector(
  featureSelector,
  state => state.isLoadingVisuals
);

export const getVisuals = createSelector(
  featureSelector,
  state => state.visuals
);

export const getDashboardId = createSelector(
  featureSelector,
  state => state.dashboardId
);


export const isLoadingDashboard = createSelector(
  featureSelector,
  state => state.loadingDashboard
);

export const getDashboard = createSelector(
  featureSelector,
  state => state.dashboard
);

export const getVisualContents = createSelector(
  featureSelector,
  state => state.visualContents
);

export const getVisualId = createSelector(
  featureSelector,
  state => state.visualId
);

export const isLoadingVisual = createSelector(
  featureSelector,
  state => state.loadingVisual
);

export const getVisual = createSelector(
  featureSelector,
  state => state.visual
);


export const getFocusedVisual = createSelector(
  featureSelector,
  state => state.focusedVisual 
);

export const hasFocusedVisual = createSelector(
  featureSelector,
  state => state.hasFocusedVisual
);


export const getLastViewedDashboardId = createSelector(
  featureSelector,
  state => state.lastViewedDashboardId
);

export const isCopyingDashboard = createSelector(
  featureSelector,
  state => state.copyingDashboard
);

export const isAddingDashboard = createSelector(
  featureSelector,
  state => state.addingDashboard
);
